__turbopack_context__.v({
  "appear-slide-left": "MegaMenu-module-scss-module__FAfbPW__appear-slide-left",
  "bounceTwice": "MegaMenu-module-scss-module__FAfbPW__bounceTwice",
  "categoryLink": "MegaMenu-module-scss-module__FAfbPW__categoryLink",
  "fade-in-bottom": "MegaMenu-module-scss-module__FAfbPW__fade-in-bottom",
  "fade-in-left": "MegaMenu-module-scss-module__FAfbPW__fade-in-left",
  "fade-in-right": "MegaMenu-module-scss-module__FAfbPW__fade-in-right",
  "fadeIn": "MegaMenu-module-scss-module__FAfbPW__fadeIn",
  "linkItem": "MegaMenu-module-scss-module__FAfbPW__linkItem",
  "linkList": "MegaMenu-module-scss-module__FAfbPW__linkList",
  "loader": "MegaMenu-module-scss-module__FAfbPW__loader",
  "megaMenu": "MegaMenu-module-scss-module__FAfbPW__megaMenu",
  "puff-in-center": "MegaMenu-module-scss-module__FAfbPW__puff-in-center",
  "puff-in-left": "MegaMenu-module-scss-module__FAfbPW__puff-in-left",
  "pulse": "MegaMenu-module-scss-module__FAfbPW__pulse",
  "pulse-contact": "MegaMenu-module-scss-module__FAfbPW__pulse-contact",
  "shake-bottom": "MegaMenu-module-scss-module__FAfbPW__shake-bottom",
  "slide-again": "MegaMenu-module-scss-module__FAfbPW__slide-again",
  "slide-in-right": "MegaMenu-module-scss-module__FAfbPW__slide-in-right",
  "stepContent-entrance": "MegaMenu-module-scss-module__FAfbPW__stepContent-entrance",
  "wrapper": "MegaMenu-module-scss-module__FAfbPW__wrapper",
});
